import { Button, ModalBody, ModalContent, ModalFooter, ModalHeader, Textarea } from "@heroui/react";
import { zodResolver } from "@hookform/resolvers/zod";
import { TRequest } from "@shared/entities";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useAppApi } from "src/appApi";
import { z } from "zod";

const formSchema = z.object({
	adminMessage: z.string().nonempty({ message: "שדה חובה" }).optional(),
});

type Form = z.infer<typeof formSchema>;

export function AdminBackRequestToDoctorModal({
	request,
	onSubmit,
}: {
	request: TRequest;
	onSubmit?: (request: Partial<TRequest>) => void;
}) {
	const { t } = useTranslation(["common", "admin"]);

	const appApi = useAppApi();

	const form = useForm<Form>({
		resolver: zodResolver(formSchema),
	});

	const _onSubmit = async (data: Form) => {
		if (!request.id) return;

		const res = await appApi.api.admin.setRequest({
			id: request.id,
			status: "pending_doctor",
			adminMessage: data.adminMessage,
		});

		if (res?.success) {
			onSubmit?.(res.request);
		} else {
			form.setError("root", { message: "global error" });
		}
	};

	return (
		<ModalContent onSubmit={form.handleSubmit(_onSubmit, console.warn)} as={"form"}>
			{(onClose) => {
				return (
					<>
						<ModalHeader>החזר בקשה לרופא</ModalHeader>
						<ModalBody className="">
							<Textarea
								label={t("common:message")}
								placeholder={t("common:message")}
								{...form.register("adminMessage", {})}
								errorMessage={form.formState.errors.adminMessage?.message}
								isInvalid={!!form.formState.errors.adminMessage?.message}
							/>
						</ModalBody>
						<ModalFooter className="">
							<Button variant="light" onPress={onClose}>
								ביטול
							</Button>
							<Button
								isLoading={appApi.loading["admin.setRequest"]}
								type="submit"
								color="primary"
							>
								אישור
							</Button>
						</ModalFooter>
					</>
				);
			}}
		</ModalContent>
	);
}
